/**
 * Adds `.is-scrolled` to a transparent-over-hero header once the page
 * scrolls past a small threshold. Throttled via requestAnimationFrame so
 * the scroll listener never fires more than once per frame (brief: "avoid
 * scroll listeners that fire excessively").
 */
(function () {
  const header = document.querySelector('[data-header][data-transparent="true"]');
  if (!header) return;

  let ticking = false;

  function update() {
    header.classList.toggle('is-scrolled', window.scrollY > 24);
    ticking = false;
  }

  window.addEventListener(
    'scroll',
    () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    },
    { passive: true }
  );

  update();
})();
